import './wizard.css';
export default {
  "dirRtl": "pf-v6-m-dir-rtl",
  "drawer": "pf-v6-c-drawer",
  "modalBox": "pf-v6-c-modal-box",
  "modifiers": {
    "finished": "pf-m-finished",
    "expanded": "pf-m-expanded",
    "danger": "pf-m-danger",
    "warning": "pf-m-warning",
    "success": "pf-m-success",
    "current": "pf-m-current",
    "expandable": "pf-m-expandable",
    "disabled": "pf-m-disabled",
    "noPadding": "pf-m-no-padding"
  },
  "wizard": "pf-v6-c-wizard",
  "wizardClose": "pf-v6-c-wizard__close",
  "wizardDescription": "pf-v6-c-wizard__description",
  "wizardFooter": "pf-v6-c-wizard__footer",
  "wizardHeader": "pf-v6-c-wizard__header",
  "wizardInnerWrap": "pf-v6-c-wizard__inner-wrap",
  "wizardMain": "pf-v6-c-wizard__main",
  "wizardMainBody": "pf-v6-c-wizard__main-body",
  "wizardNav": "pf-v6-c-wizard__nav",
  "wizardNavItem": "pf-v6-c-wizard__nav-item",
  "wizardNavLink": "pf-v6-c-wizard__nav-link",
  "wizardNavLinkMain": "pf-v6-c-wizard__nav-link-main",
  "wizardNavLinkStatusIcon": "pf-v6-c-wizard__nav-link-status-icon",
  "wizardNavLinkToggle": "pf-v6-c-wizard__nav-link-toggle",
  "wizardNavLinkToggleIcon": "pf-v6-c-wizard__nav-link-toggle-icon",
  "wizardNavList": "pf-v6-c-wizard__nav-list",
  "wizardOuterWrap": "pf-v6-c-wizard__outer-wrap",
  "wizardTitle": "pf-v6-c-wizard__title",
  "wizardTitleText": "pf-v6-c-wizard__title-text",
  "wizardToggle": "pf-v6-c-wizard__toggle",
  "wizardToggleIcon": "pf-v6-c-wizard__toggle-icon",
  "wizardToggleList": "pf-v6-c-wizard__toggle-list",
  "wizardToggleListItem": "pf-v6-c-wizard__toggle-list-item",
  "wizardToggleNum": "pf-v6-c-wizard__toggle-num",
  "wizardToggleSeparator": "pf-v6-c-wizard__toggle-separator",
  "wizardToggleStatusIcon": "pf-v6-c-wizard__toggle-status-icon"
};